import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import { LanguageProvider, useLanguage } from './context/LanguageContext';
import { ThemeProvider } from './context/ThemeContext';
import Background from './components/Background';
import Hero from './components/Hero';
import FeaturedProject from './components/FeaturedProject';
import Projects from './components/Projects';
import About from './components/About';
import Contact from './components/Contact';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';
import MasarTechPage from './masar-tech/MasarTechPage';
import { LanguageProvider as MasarTechLanguageProvider } from './masar-tech/context/LanguageContext';

function HomePage() {
  const { hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const id = hash.replace('#', '');
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  }, [hash]);

  return (
    <>
      <Background />
      <Navbar />
      <Hero />
      <FeaturedProject />
      <Projects />
      <About />
      <Contact />
      <Footer />
      <WhatsAppButton />
    </>
  );
}

function MasarTechRoute() {
  const { language } = useLanguage();

  return (
    <>
      <Navbar />
      <MasarTechLanguageProvider language={language}>
        <MasarTechPage />
      </MasarTechLanguageProvider>
    </>
  );
}

function App() {
  return (
    <ThemeProvider>
      <LanguageProvider>
        <BrowserRouter>
          <div className="App">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/masar-tech" element={<MasarTechRoute />} />
            </Routes>
          </div>
        </BrowserRouter>
      </LanguageProvider>
    </ThemeProvider>
  );
}

export default App;

